@if (configuration) {
    <section
        class="nw-promo-block__container"
        [class.nw-promo-block__container--right]="configuration.layout === 'right'"
    >
        <div class="nw-promo-block__container__content">
            @if (configuration.icon) {
                <img
                    class="nw-promo-block__container__content__icon"
                    [ngSrc]="configuration.icon.path"
                    [alt]="configuration.icon.alt || ''"
                    width="32"
                    height="32"
                />
            }

            <h2
                class="nw-promo-block__container__content__header"
                [innerHTML]="configuration.header | highlightText"
            ></h2>

            @if (configuration.content) {
                <div
                    class="nw-promo-block__container__content__body"
                    [innerHTML]="configuration.content | sanitizeHtml"
                ></div>
            }

            @if (configuration.cta && configuration.cta.label) {
                <a
                    [href]="configuration.cta.path"
                    class="nw-button nw-button--primary nw-button--m nw-promo-block__container__content__cta"
                >
                    <span [innerHTML]="configuration.cta.label | sanitizeHtml"></span>
                </a>
            }
        </div>

        <div class="nw-promo-block__container__media">
            @if (configuration.media.type === 'image') {
                <img
                    class="nw-promo-block__container__media__image"
                    [ngSrc]="configuration.media.path"
                    [alt]="configuration.media.alt || ''"
                    fill
                />
                @if (configuration.imageText || configuration.imageTextSub) {
                    <div
                        class="nw-promo-block__container__media__side-text"
                        [class.nw-promo-block__container__media__side-text--black]="
                            configuration.imageTextColor === 'black'
                        "
                    >
                        @if (configuration.imageText) {
                            <p [innerHTML]="configuration.imageText | sanitizeHtml"></p>
                        }
                        @if (configuration.imageTextSub) {
                            <p
                                [innerHTML]="configuration.imageTextSub | sanitizeHtml"
                            ></p>
                        }
                    </div>
                }
            }

            @if (configuration.media.type === 'video') {
                <video
                    #videoEl
                    class="nw-promo-block__container__media__video"
                    autoplay
                    loop
                    muted
                    playsinline
                    disablepictureinpicture
                    disableremoteplayback
                    [poster]="configuration.media.poster"
                >
                    <source [src]="configuration.media.path" type="video/mp4" />
                </video>
            }
        </div>
    </section>
}
